import * as React from 'react';
import { ReactNode } from 'react';

import { createSafeElementType } from '../index';

import { captureException } from './ErrorsReporting/ErrorsReporting';

export const reportExportedComponentError = (error: Error, errorInfo?: object): void => {
    captureException(error, { extra: errorInfo });
};

export const safeComponentHOC = <P extends {}>(componentClass: React.ComponentClass<P>): React.ComponentClass<P> => {
    if (componentClass === undefined) {
        return class EmptyComponent extends React.Component<P> {
            componentDidMount(): void {
                reportExportedComponentError(new Error('undefined component render'));
            }
            render(): ReactNode {
                return null;
            }
        };
    }

    return class extends componentClass {
        componentDidCatch(error: Error, errorInfo: object): void {
            reportExportedComponentError(error, errorInfo);
        }
    };
};

export const safeCreateElement: createSafeElementType = <P extends {}>(
    componentClass: React.ComponentClass<P>,
    props: P,
    children: ReactNode[]
): React.ReactElement<P> => {
    return React.createElement<P>(safeComponentHOC(componentClass), props, children);
};
